import state from './state'
import mutations from './mutations'
import actions from './actions'

export const states = {
  namespaced: true,
  actions,
  state,
  mutations
}
